import type { TableTabResponse } from '../types';

const TABLE_MOCK_DATA: TableTabResponse = {
  type: 'table',
  tableRows: [
    {
      no: 1,
      teamName: 'Arsenal FC',
      leagueName: 'Premier League',
      playedMatches: 34,
      wins: 22,
      draws: 7,
      losses: 5,
      points: 73,
      form: ['W', 'W', 'L', 'L', 'W'],
      qualification: 'Champions League',
      color: 'green',
      inPlay: false,
      jersey:
        'https://widget.demo.suzumuchi.dk/icons/prematch/jerseys/england_premier_league/arsenal.png',
      flag: null,
    },
    {
      no: 2,
      teamName: 'Manchester City FC',
      leagueName: 'Premier League',
      playedMatches: 33,
      wins: 21,
      draws: 7,
      losses: 5,
      points: 70,
      form: ['D', 'D', 'W', 'W', 'W'],
      qualification: 'Champions League',
      color: 'green',
      inPlay: false,
      jersey:
        'https://widget.demo.suzumuchi.dk/icons/prematch/jerseys/england_premier_league/manchester_city.png',
      flag: null,
    },
    {
      no: 3,
      teamName: 'Liverpool FC',
      leagueName: 'Premier League',
      playedMatches: 34,
      wins: 17,
      draws: 7,
      losses: 10,
      points: 58,
      form: ['D', 'L', 'W', 'W', 'W'],
      qualification: null,
      color: null,
      inPlay: false,
      jersey:
        'https://widget.demo.suzumuchi.dk/icons/prematch/jerseys/england_premier_league/liverpool.png',
      flag: null,
    },
  ],
  groups: null,
  knockout: null,
  colorLegend: [
    { color: 'green', label: 'Champions League', description: 'Champions League' },
    { color: 'yellow', label: 'UEFA Europa League', description: 'UEFA Europa League' },
  ],
  totalTeams: 20,
  totalGroups: null,
  leagueName: 'Premier League',
};

export default TABLE_MOCK_DATA;
